import { motion } from 'framer-motion';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_lesson-card-manager/artifacts/zd0x6jcg_c982a405-739a-4717-a6a0-d9774dc13353_20251118_231830_0000.png";

export default function LoadingSpinner({ text = "Laden..." }) {
    return (
        <div className="min-h-screen bg-[#1A202C] flex flex-col items-center justify-center">
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                className="mb-6"
            >
                <div className="w-20 h-20 rounded-full border-4 border-[#4A5568] border-t-[#D4A537] flex items-center justify-center">
                    <img 
                        src={LOGO_URL} 
                        alt="Loading" 
                        className="w-12 h-12 object-contain"
                    />
                </div>
            </motion.div>
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="text-gray-400 text-sm"
            >
                {text}
            </motion.p>
        </div>
    );
}

export function InlineSpinner({ text = "Laden..." }) {
    return (
        <div className="flex flex-col items-center justify-center py-16">
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                className="mb-4"
            >
                <div className="w-14 h-14 rounded-full border-3 border-[#4A5568] border-t-[#D4A537] flex items-center justify-center">
                    <img 
                        src={LOGO_URL} 
                        alt="Loading" 
                        className="w-8 h-8 object-contain"
                    />
                </div>
            </motion.div>
            <p className="text-gray-500 text-sm">{text}</p>
        </div>
    );
}
